import { t } from "i18next";
import { AlertVariant } from "./AlertDialogDAC7.model";

export const showAlertDialog = (
  variant: AlertVariant,
  status: string
): boolean => {
  return (
    (variant === "PRINCIPAL" &&
      (status === "ADDITIONAL_INFO_NEEDED" || status === "SELLING_BLOCKED")) ||
    (variant === "SELL" && status === "SELLING_BLOCKED")
  );
};

export const getTitle = () => {
  return {
    PRINCIPAL: {
      ADDITIONAL_INFO_NEEDED: t("dac7-alert-dialog-title"),
      SELLING_BLOCKED: t("dac7-alert-paused-products-title"),
    },
  };
};

export const getDescription = () => {
  return {
    PRINCIPAL: {
      ADDITIONAL_INFO_NEEDED: t("dac7-alert-dialog-description"),
      SELLING_BLOCKED: t("dac7-alert-paused-products-description"),
    },
    SELL: {
      SELLING_BLOCKED: t("dac7-alert-sell-description"),
    },
  };
};

export const getCancelButtonLabel = () => {
  return {
    PRINCIPAL: t("dac7-alert-dialog-close"),
    SELL: t("dac7-alert-sell-close"),
  };
};
